module.exports = __webpack_public_path__ + "img/chalk-box-2024.f5fbcc90.jpg";